import React, { useEffect } from 'react'
import { RouteComponentProps } from '@reach/router'
import { useStateValue } from '../../components/state'
import { House } from '../../components/house'

export const houseMarkers = [
  {
    title: 'Garden bores',
    content: `Bores use groundwater to irrigate lawns and gardens. If you have a bore, you could be using up to 70% groundwater in your home.`,
    coords: {
      x: 22,
      y: 58
    },
    link: 'https://begroundwaterwise.wa.gov.au/'
  },
  {
    title: 'Get sprinkler smart',
    content: `We use over 40% of our drinking water in the garden. Stick to your watering days and reduce sprinkler run times to conserve this precious resource.`,
    coords: {
      x: 69,
      y: 67
    },
    link:
      'https://www.watercorporation.com.au/Waterwise/Waterwise-advice/Garden/Sprinklers-and-irrigation'
  },
  {
    title: 'Washing the car',
    content: `Wash your car with a bucket and sponge on the lawn, not in the driveway. You'll keep the dirty water away from drains and give your lawn an extra drink!`,
    coords: {
      x: 50,
      y: 80
    },
    link: 'https://www.watercorporation.com.au/Waterwise/Waterwise-advice'
  },
  {
    title: 'Protect our rivers',
    content: `Stormwater collected by drains isn't treated before going back to the environment. Be careful using chemicals near drains so they don’t end up in our rivers and waterways.`,
    coords: {
      x: 83,
      y: 62
    },
    link:
      'https://www.watercorporation.com.au/Developing-and-building/Land-planning/Drainage'
  },
  {
    title: 'Collect tap water',
    content: `Your home's tap water is treated to the highest quality, so don’t let it go to waste! Collect water while waiting for it to heat up and use it to boil the kettle, clean your vegetables or water the garden.`,
    coords: {
      x: 40,
      y: 59
    },
    link:
      'https://www.watercorporation.com.au/Waterwise/Waterwise-advice/Kitchen-and-laundry'
  },
  {
    title: 'Use your washing machine wisely',
    content: `Washing machines account for 16% of household water use. Save water by switching to a front loader and running only when it's full.`,
    coords: {
      x: 44,
      y: 51
    },
    link:
      'https://www.watercorporation.com.au/Waterwise/Waterwise-advice/Kitchen-and-laundry'
  },
  {
    title: 'Think before your flush',
    content: `Around 9% of clean household water goes down the toilet. Every flush uses precious water, so use the half flush when you can and only flush the 3 P's - paper, pee and poo - down the loo.`,
    coords: {
      x: 47,
      y: 50
    },
    link:
      'https://www.watercorporation.com.au/Waterwise/Waterwise-advice/Bathroom'
  },
  {
    title: 'Take shorter showers',
    content: `Cutting your shower time by just 2 minutes can result in up to a 30% water saving in shower use.`,
    coords: {
      x: 53,
      y: 43
    },
    link:
      'https://www.watercorporation.com.au/Waterwise/Waterwise-advice/Bathroom'
  }
]

export const How: React.FC<RouteComponentProps> = () => {
  const [, dispatch] = useStateValue()

  // Filter map pins to all
  useEffect(() => {
    dispatch({
      type: 'setActiveMarkerSet',
      payload: { activeMarkerSet: 'default' }
    })
    dispatch({
      type: 'setActiveMarkerType',
      payload: { activeMarkerType: 'all' }
    })
    dispatch({ type: 'setSidePanelFull', payload: { sidePanelFull: true } })
  }, [dispatch])

  return <House markers={houseMarkers} />
}
